import React from "react";
import moment from "moment";
import { Order } from "../../store/slices/order/types";

const PatientInfo = ({ orderDetails }: { orderDetails: Order| null }) => {
  return (
    <div className="border-[1px] border-[#E5E9F2] rounded-[1.5rem] p-3 md:p-8 mb-10">
      <div className="flex  flex-col md:justify-between lg:flex-row items-start">
        <div className="">
          <div className="text-[#0C4654] text-[0.875rem] mb-4">
            Name:
            <strong>
              {" "}
              {orderDetails?.user?.firstName} {orderDetails?.user?.lastName}{" "}
            </strong>
          </div>
          <div className="text-[#0C4654] text-[0.875rem]">
            Date of Birth:
            <strong>
              {" "}
              {orderDetails?.user?.dateOfBirth ? moment(orderDetails?.user?.dateOfBirth).format("DD-MM-YYYY") : "----------"}
            </strong>
          </div>
        </div>
        <div className="">
          <div className="text-[#0C4654] text-[0.875rem] mb-4">
            Gender:
            <strong> {orderDetails?.user?.gender}</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientInfo;
